<ng-template #tooltipContent let-entry="entry">
  <div class="info-description">
    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.speedRPM' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.speedRPM }}</span>
    </p>

    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.outputHP' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.outputHP }}</span>
    </p>

    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.voltage' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.voltage }}</span>
    </p>

    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.frameSize' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.frameSize }}</span>
    </p>

    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.outputKW' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.outputKW }}</span>
    </p>

    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.mounting' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.mounting }}</span>
    </p>

    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.phase' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.phase }}</span>
    </p>

    <p>
      <span class="title ff-bold m-r-4">{{ 'quotes.quoteItem.enclosure' | cxTranslate }}:</span>
      <span class="value">{{ entry.product?.enclosure }}</span>
    </p>
  </div>
</ng-template>

<td>
  <span class="responsive-title">{{ 'quotes.quoteItem.catalogNumber' | cxTranslate }}: </span>

  {{ entry.product?.catalogNumber || '---' }}
</td>

<td class="col-part">
  <span class="responsive-title">{{ 'quotes.quoteItem.partNumber' | cxTranslate }}: </span>

  {{ entry.product?.partNumber || '---' }}
</td>

<td class="col-qty">
  <span class="responsive-title">{{ 'quotes.quoteItem.quoteQty' | cxTranslate }}: </span>

  <div class="form-group">
    <label>
      <input
        #qty
        class="form-control js-qty"
        type="text"
        name="qty"
        [maxLength]="7"
        placeholder=""
        [value]="(entry.qty || 0)?.toString()"
        (blur)="setQty(qty.value)"
        [attr.data-entry]="entry.code"
      />
    </label>
  </div>
</td>

<td>
  <span class="responsive-title">{{ 'quotes.quoteItem.orderFrequency' | cxTranslate }}: </span>

  <div class="form-group">
    <label>
      <select #frequency class="form-control js-frequency" [attr.data-entry]="entry.code" (change)="setFrequency(frequency.value)">
        @if (entry.frequency) {
          <option value="" disabled>{{ 'generic.selectAnOption' | cxTranslate }}</option>
        } @else {
          <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
        }

        <ng-container *ngFor="let item of frequencies">
          @if (item.code === entry.frequency) {
            <option [attr.aria-label]="item.label" value="{{ item.code }}" selected>
              {{ item.label }}
            </option>
          } @else {
            <option [attr.aria-label]="item.label" value="{{ item.code }}">
              {{ item.label }}
            </option>
          }
        </ng-container>
      </select>
    </label>
  </div>
</td>

<td class="col-description">
  <span class="responsive-title">{{ 'quotes.quoteItem.description' | cxTranslate }}: </span>

  <div class="content">
    <span [innerHTML]="entry.product?.name"></span>

    @if (entry.product?.isCustom) {
      <span *ngIf="entry.product?.application" class="m-l-4">({{ entry.product?.application }})</span>

      <span>
        <ng-container *limitUp="DEVICE_SIZE.DESKTOP">
          <span class="d-flex material-symbols-outlined m-l-4" [pTooltip]="tooltip"> display_settings </span>
        </ng-container>

        <button class="btn-tooltip" [pTooltip]="tooltip" tooltipEvent="focus" *smallerThan="DEVICE_SIZE.DESKTOP">
          <span class="d-flex material-symbols-outlined m-l-4"> display_settings </span>
        </button>

        <ng-template #tooltip>
          <ng-container *ngTemplateOutlet="tooltipContent; context: { entry }"> </ng-container>
        </ng-template>
      </span>
    }
  </div>
</td>

<td class="col-unit-price">
  <span class="responsive-title">{{ 'quotes.quoteItem.unitPrice' | cxTranslate }}: </span>

  <span class="value">
    {{ entry.product?.price?.formattedValue || '---' }}
  </span>
</td>

<td class="col-req-price">
  <span class="responsive-title">{{ 'quotes.quoteItem.requestPrice' | cxTranslate }}: </span>

  <div class="form-group">
    <label>
      <input
        #reqPrice
        class="form-control reset-type-number js-req-price"
        type="text"
        name="reqPrice"
        maxlength="20"
        [value]="entry.reqPrice"
        (blur)="setReqPrice(reqPrice.value)"
        [attr.data-entry]="entry.code"
        prefix="$ "
        mask="separator.2"
        thousandSeparator=","
      />
    </label>
  </div>
</td>

<td class="col-actions">
  <button type="button" class="btn btn-danger btn-sm" (click)="removeProduct(entry)">
    <span class="material-symbols-outlined"> delete </span>
    {{ 'quotes.quoteItem.remove' | cxTranslate }}
  </button>
</td>
